import { useContext } from "react";
import { PhotoUploadSessionContext } from "../contexts/PhotoUploadSession";

/**
 * In-memory race-photo upload session (review / running / done).
 *
 * @returns {object}
 */
function usePhotoUploadSession() {
  return useContext(PhotoUploadSessionContext);
}

export default usePhotoUploadSession;
